import SearchInput from 'common/components/SearchInput';
import React, { useMemo } from 'react';
import ChatListUser from '../ChatListUser';

import TestAvatar1 from '../../images/test-avatar1.png';
import TestAvatar2 from '../../images/test-avatar2.png';
import TestAvatar3 from '../../images/test-avatar3.png';
import DefaultAvatar from 'common/images/default-avatar.png';
import styled from '@emotion/styled';

const MockAvatarArray = [
  TestAvatar1,
  TestAvatar2,
  TestAvatar3,
  DefaultAvatar,
];

function getRandomAvatar() {
  return MockAvatarArray[Math.floor(Math.random() * MockAvatarArray.length)];
}

type ChatListUserArray = {
  id: number | string;
  name: string;
  text: string;
  image?: string;
};

const AddChatButton = styled.button`
  width:100%;
  height: 38px;
  min-height: 38px;
  display:flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  font-size: 16px;
  color: ${(props) => props.theme.colors.primaryTextColor};
  border: 1px solid ${(props) => props.theme.colors.gray};
  // background is primary color but with 0.1 opacity
  background-color: ${(props) => props.theme.colors.primaryColor + '1A'};
  transition: all 0.2s ease-in-out;
  &:hover {
    // background is primary color but with 0.25 opacity
    background-color: ${(props) => props.theme.colors.primaryColor + '40'};
  }
`;

function createMockListUserArray(count = 10) {
  const array: ChatListUserArray[] = [];
  for (let i = 0; i < count; i++) {
    const randomNames = ['John', 'Jack', 'Alex', 'Bob', 'Mike', 'Sara', 'Jane', 'Kate', 'Ann', 'Liza', 'Linda', 'Lana', 'Lara', 'Lena', 'Lora', 'Luna', 'Lola', 'Luda', 'Luba', 'Lina', 'Lida', 'Lana', 'Lara', 'Lena', 'Lora', 'Luna', 'Lola', 'Luda', 'Luba', 'Lina', 'Lida'];
    const randomName = randomNames[Math.floor(Math.random() * randomNames.length)];
    const randomMessage = Math.random().toString(36).substring(2, Math.floor(Math.random() * 20) + 2);
    const allowedEmoji = ['🤓', '🤣', '🤔'];
    const emojiChance = .2;
    const randomEmoji = Math.random() < emojiChance ? allowedEmoji[Math.floor(Math.random() * allowedEmoji.length)] : '';
    array.push({
      id: i,
      name: `${randomName}`,
      text: `${randomMessage} ${randomEmoji}`,
      image: getRandomAvatar(),
    });
  }
  return array;
}


export default function ChatSidebar() {
  const count = 30;
  const [chatList] = useMemo(() => [createMockListUserArray(count)], [count]);
  return (
        <div className='chat-sidebar-wrapper'>
            <SearchInput wrapperStyle={{ width:'100%' }} style={{ fontSize:'14px' }} iconSize={20} />
            <div className='scrollbar chat-sidebar-list'>
                {chatList.map((user) => (
                    <ChatListUser key={user.id} id={user.id} name={user.name} text={user.text} image={user.image} />
                ))}
            </div>
            <AddChatButton>
              Новий чат
            </AddChatButton>
        </div>
  );
}